import api from "./api.js";
import store from "@/store";

export default {
	path: "/conversion-reports",
	name: "conversion-reports",
	excludeSeo: true,
	meta: { title: "Conversion reports", requireAuth: true },
	async beforeEnter(to, from, next) {
		try {
			const access = await api.getAccess();
			next(access.canExport ? undefined : { name: "main" });
		} catch (error) {
			store.commit("noty/NEW", { type: "error", message: error.message });
			next({ name: "main" });
		}
	},
	component: () => import(/* webpackChunkName: "conversion-reports" */ "./ConversionReports.vue"),
};
